import { PotentialBet, UnmatchedBet } from "@ppb/bet-engine";
import type { BetslipExchangeMarketRunner } from "../exchange-markets/ExchangeMarkets.types";
import type { URN, ExchangeSide } from "../../../types";
import type { BetslipApplicationState } from "../BetslipApplicationState";

export type BetslipSelectionDescription = {
  title: string;
  subtitle: string;
};

export const isOfRunner = (potentialBet: PotentialBet, runner: BetslipExchangeMarketRunner): boolean =>
  potentialBet.selectionId === runner.selectionId && potentialBet.handicap === runner.handicap;

export const getUnmatchedBets = (state: BetslipApplicationState, marketUrn: URN, betIds: string[]): UnmatchedBet[] => {
  const marketState = state.exchangeBetting[marketUrn];

  if (!marketState) {
    return [];
  }

  return marketState.unmatchedBets.filter((bet) => betIds.includes(bet.id.slice(2)));
};

export const getRunnerSPBet = (
  state: BetslipApplicationState,
  marketUrn: URN,
  marketRunner: BetslipExchangeMarketRunner,
  side: ExchangeSide,
) => {
  const marketState = state.exchangeBetting[marketUrn];
  return marketState?.potentialSPBets?.find(
    (bet) =>
      bet.selectionId === marketRunner.selectionId && bet.handicap === marketRunner.handicap && bet.side === side,
  );
};
